<template>
  <cadastro-base
    :salvar="salvarTudo"
    :cancelar="cancelar"
    :is-loading="isLoading"
  >
    <template slot="conteudo">
      <b-tabs content-class="mt-2">

        <!-- ── Aba Dados ─────────────────────────────────────────────────── -->
        <b-tab
          title="Dados"
          active
          no-body
        >
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Nome completo"
            label-for="nomeCompletoInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="'required|nomeCompleto'"
              name="Nome completo"
            >
              <b-form-input
                id="nomeCompletoInput"
                v-model="form.nomeCompleto"
                :state="errors.length > 0 ? false : null "
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="CPF"
            label-for="cpfInput"
          >
            <validation-provider
              #default="{ errors }"
              :rules="'required|cpfDocumento'"
              name="CPF"
            >
              <masked-input
                :id="'cpfInput'"
                ref="cpf"
                v-model="form.cpf"
                :mask="cpf"
                :class="['form-control', {'is-invalid': validacao.cpf}]"
                @blur.native="validarCpfPorApi"
              />
              <small class="text-danger">{{ errors[0] || validacao.cpf }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="CRC"
                label-for="crcInput"
              >
                <validation-provider
                  #default="{ errors }"
                  :rules="{required: form.contador}"
                  name="CRC"
                >
                  <b-input
                    :id="'crcInput'"
                    ref="crc"
                    v-model="form.crc"
                    :disabled="!form.contador"
                    :state="errors.length > 0 ? false : null "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-checkbox
                v-model="form.contador"
                size="sm"
                class="detail-check-sm"
                @change="form.crc = ''"
              >
                Considerar como contador
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <dados-acesso
            ref="dadosAcesso"
            v-model="form.dadosAcesso"
            :valida-login="validarLoginPorApi"
            :email-feedback="validacao.login"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vinculo-empresas
            v-model="empresasBase"
            :cadastro-usuario="true"
            :visualizacao-opcoes="visualizacao"
            :filtros-vinculadas="filtrosVinculadas"
            :filtros-nao-vinculadas="filtrosNaoVinculadas"
            :tem-busca="true"
            @eventClickCustom="clickCustomEmpresas($event)"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <configurar-permissoes
            v-model="form.permissoes"
            :administrador="form.administrador"
            @administrador="isAdmin"
          />
        </b-col>
      </b-row>
        </b-tab>

        <!-- ── Aba SMTP ──────────────────────────────────────────────────── -->
        <b-tab
          v-if="form.id"
          title="Configuração SMTP"
          no-body
        >
      <b-row class="mt-3">
        <b-col cols="12">
          <p class="text-muted small mb-2">
            Ao informar o SMTP a plataforma enviará os e-mails com os dados cadastrados por usuário. <strong>**Cadastro não obrigatório**</strong>
          </p>
          <b-alert
            v-if="smtpForm.estaEmGrupo"
            show
            variant="warning"
            class="mb-2"
          >
            <feather-icon
              icon="UsersIcon"
              class="mr-1"
            />
            Este usuário pertence ao grupo <strong>{{ smtpForm.nomeGrupo }}</strong>. As configurações individuais estão inativas enquanto ele fizer parte do grupo.
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Servidor"
            label-for="smtpServidor"
          >
            <b-form-input
              id="smtpServidor"
              v-model="smtpForm.servidor"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Porta"
            label-for="smtpPorta"
          >
            <b-form-input
              id="smtpPorta"
              v-model.number="smtpForm.porta"
              type="number"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Criptografia"
            label-for="smtpCriptografia"
          >
            <b-form-select
              id="smtpCriptografia"
              v-model="smtpForm.criptografia"
              :options="criptografiaOpcoes"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="E-mail remetente"
            label-for="smtpEmail"
          >
            <b-form-input
              id="smtpEmail"
              v-model="smtpForm.emailRemetente"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Login SMTP"
            label-for="smtpLogin"
          >
            <b-form-input
              id="smtpLogin"
              v-model="smtpForm.login"
              placeholder="Se diferente do e-mail"
              :disabled="smtpForm.estaEmGrupo"
            />
            <small class="text-muted">Opcional</small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Senha"
            label-for="smtpSenha"
          >
            <senha-input
              id="smtpSenha"
              v-model="smtpForm.senha"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Descrição do remetente"
            label-for="smtpDescRemetente"
          >
            <b-form-input
              id="smtpDescRemetente"
              v-model="smtpForm.descRemetente"
              :disabled="smtpForm.estaEmGrupo"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Assinatura de e-mail">
            <upload-e-visualizacao
              id="smtpAssinaturaInput"
              ref="uploadSmtpAssinatura"
              :value="smtpForm.assinatura"
              titulo="assinatura"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="smtpForm.id && !smtpForm.estaEmGrupo">
        <b-col>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="removerSmtp"
          >
            Remover SMTP
          </b-button>
        </b-col>
      </b-row>
        </b-tab>

      </b-tabs>
    </template>
  </cadastro-base>
</template>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.tabela-servicos {
  .vgt-left-align {
    pointer-events: none;
  }

  .vgt-right-align {
    pointer-events: none;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}

.servico-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.disable-table {
  pointer-events: none;
}
</style>

<script>
import api from '@/app/usuario/shared/services/api'
import {
  defineComponent, shallowRef, computed, triggerRef,
} from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { useRouter } from '@core/utils/utils'
import { required } from '@validations'
import { cpfDocumento } from '@pilar/plugins/p-validation/p-validation'
import { cpf } from '@pilar/mixins/mascaras'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import { ValidationProvider } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import useUsuario from './useUsuario'
import { validaCpf, validaEmail } from '../../services/validacaoApi'
import ConfigurarPermissoes from '../configurar-permissoes/ConfigurarPermissoes.vue'

export default defineComponent({
  name: 'UsuarioInterno',
  components: {
    ValidationProvider,
    ConfigurarPermissoes,
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
    DadosAcesso: () => import('@/app/shared/components/dados-acesso/DadosAcesso.vue'),
    VinculoEmpresas: () => import('@pilar/components/vinculo-empresas/VinculoEmpresas.vue'),
    UploadEVisualizacao: () => import('@pilar/plugins/upload-e-visualizacao/UploadEVisualizacao.vue'),
    SenhaInput: () => import('@pilar/components/senha-input/SenhaInput.vue'),
  },
  props: {
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtrosVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosNaoVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      smtpForm: {
        id: null,
        servidor: '',
        porta: 587,
        criptografia: 'tsl',
        emailRemetente: '',
        login: '',
        senha: '',
        descRemetente: '',
        assinatura: null,
        estaEmGrupo: false,
        nomeGrupo: null,
      },
      criptografiaOpcoes: [
        { value: 'none', text: 'Nenhuma' },
        { value: 'ssl', text: 'SSL' },
        { value: 'tsl', text: 'TLS' },
      ],
    }
  },
  setup() {
    const validacao = shallowRef({ cpf: '', login: '' })
    const cpfValido = computed({
      get: () => validacao.cpf,
    })
    const { route } = useRouter()
    const modoEdicao = route.value.path.indexOf('editar') > 0
    const {
      salvar,
      carregar,
      cancelar,
      form,
      dadosAcesso,
      carregarEmpresasParaVinculo,
    } = useUsuario(modoEdicao, validacao)

    if (modoEdicao) {
      carregar(route.value.params.id)
    } else {
      carregarEmpresasParaVinculo()
    }

    const validarCpfPorApi = () => {
      validaCpf(form.value.cpf, form.value.id)
        .then(() => {
          validacao.value.cpf = ''
          triggerRef(validacao)
        })
        .catch(err => {
          validacao.value.cpf = err.message
          triggerRef(validacao)
        })
    }
    const validarLoginPorApi = () => {
      validaEmail(form.value.dadosAcesso.login, form.value.id)
        .then(() => {
          validacao.value.login = ''
          triggerRef(validacao)
        })
        .catch(err => {
          validacao.value.login = err.message
          triggerRef(validacao)
        })
    }

    const empresasBase = computed({
      get() {
        if (form.value.administrador) {
          const empresasAdmin = [
            ...form.value.empresasVinculadas.vinculadas,
            ...form.value.empresasVinculadas.naoVinculadas,
          ]
          return {
            vinculadas: empresasAdmin,
            naoVinculadas: [],
          }
        }
        return form.value.empresasVinculadas
      },
      set(novoValor) {
        if (!form.value.administrador) {
          form.value.empresasVinculadas = novoValor
        }
      },
    })

    return {
      salvar,
      carregar,
      cancelar,
      validarCpfPorApi,
      validarLoginPorApi,
      form,
      empresasBase,
      validacao,
      dadosAcesso,
      cpfValido,
      cpf,
      cpfDocumento,
      required,
      visualizacao: {
        evento(id, filtros) {
          return api.getEmpresasPorUsuario(id, filtros)
        },
      },
      isLoading: true,
    }
  },
  created() {
    EventBus.$on('finalizaLoading', () => {
      this.atualizaLoading()
      this.carregarSmtp()
    })
  },
  methods: {
    async salvarTudo() {
      if (this.form.id) {
        try {
          await this.salvarSmtp()
        } catch (err) {
          this.$erro(err?.response?.data?.message || 'Erro ao salvar configuração de SMTP')
          return null
        }
      }
      return this.salvar()
    },
    atualizaLoading() {
      this.isLoading = false
    },
    isAdmin(evento) {
      this.form.administrador = evento
    },
    async carregarSmtp() {
      if (!this.form.id) return
      try {
        const res = await api.getSmtpUsuario(this.form.id)
        if (res && res.data) {
          const d = res.data
          this.smtpForm = {
            id: d.id || null,
            servidor: d.servidor || '',
            porta: d.porta || 587,
            criptografia: d.criptografia || 'tsl',
            emailRemetente: d.emailRemetente || '',
            login: d.login || '',
            senha: d.senha || '',
            descRemetente: d.descRemetente || '',
            assinatura: d.assinatura || null,
            estaEmGrupo: d.estaEmGrupo || false,
            nomeGrupo: d.nomeGrupo || null,
          }
        }
      } catch {
        // sem SMTP individual cadastrado — estado inicial é mantido
      }
    },
    async salvarSmtp() {
      if (!this.form.id || !this.smtpForm.servidor) return
      const file = this.$refs.uploadSmtpAssinatura?.getFile() || null
      const body = {
        id: this.smtpForm.id || 0,
        usuarioId: this.form.id,
        servidor: this.smtpForm.servidor,
        porta: this.smtpForm.porta,
        criptografia: this.smtpForm.criptografia,
        emailRemetente: this.smtpForm.emailRemetente,
        login: this.smtpForm.login,
        senha: this.smtpForm.senha,
        descRemetente: this.smtpForm.descRemetente,
        assinatura: file ? null : this.smtpForm.assinatura,
      }
      const res = await api.salvarSmtpUsuario(this.form.id, file, body)
      if (res && res.data) {
        this.smtpForm.id = res.data.id
      }
    },
    async removerSmtp() {
      if (!this.form.id) return
      try {
        await api.removerSmtpUsuario(this.form.id)
        this.smtpForm = {
          id: null,
          servidor: '',
          porta: 587,
          criptografia: 'tsl',
          emailRemetente: '',
          login: '',
          senha: '',
          descRemetente: '',
          assinatura: null,
        }
      } catch {
        // erro exibido pelo interceptor do axios
      }
    },
  },
})
</script>
